import React from 'react'


function Errorpage() {
  return (
    <>
        <div id='not-found bg-light'>
        <div style={{minHeight:"100vh"}} className='container d-flex flex-column justify-content-center align-items-center'>
            <h1 className='display-1'>404</h1>
            <h1>Page Not Found</h1>
            <a href='/' className='btn bg-secondary text-white mt-1'>Return To Home Page</a>
        </div>
        </div>
    </>
  )
}

export default Errorpage